import axios from "axios";
import { sameOriginUrl } from "./sameOrigin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Rewrite absolute Emergent-hosted URLs in EVERY response to same-origin paths.
// This keeps `<img src>`, video URLs, and any other asset in the DOM from
// leaking the platform hostname when inspected.
function _rewrite(value) {
  if (typeof value === "string") return sameOriginUrl(value);
  if (Array.isArray(value)) return value.map(_rewrite);
  if (value && typeof value === "object") {
    const out = {};
    for (const k in value) out[k] = _rewrite(value[k]);
    return out;
  }
  return value;
}
api.interceptors.response.use((response) => {
  try {
    response.data = _rewrite(response.data);
  } catch (_e) { /* leave data as-is on any error */ }
  return response;
});

export const fetchProducts = (opts) => {
  let params = {};
  if (typeof opts === "string") params = { collection: opts };
  else if (opts && typeof opts === "object") params = opts;
  return api.get("/products", { params }).then((r) => r.data);
};
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchEvents = () => api.get("/events").then((r) => r.data);
export const fetchArtists = () => api.get("/artists").then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchCollections = () => api.get("/collections").then((r) => r.data);
export const fetchNavItems = () => api.get("/nav-items").then((r) => r.data);
export const fetchTags = () => api.get("/tags").then((r) => r.data);
export const fetchEventTypes = () => api.get("/event-types").then((r) => r.data);

// Customer auth + portal
export const registerCustomer = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const fetchCustomerOrders = () => api.get("/portal/customer/orders").then((r) => r.data);
export const sendCustomerContact = (payload) => api.post("/portal/customer/contact", payload).then((r) => r.data);
export const fetchCustomerMessages = () => api.get("/portal/customer/messages").then((r) => r.data);

// Public contact form
export const sendPublicContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
export const placeOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const buyTickets = (payload) => api.post("/tickets", payload).then((r) => r.data);
export const fetchRoster = () => api.get("/roster").then((r) => r.data);
export const fetchArtist = (slug) => api.get(`/artists/${slug}`).then((r) => r.data);
export const fetchLookbook = () => api.get("/lookbook").then((r) => r.data);
export const fetchSiteContent = () => api.get("/site-content").then((r) => r.data);
export const fetchSiteLock = () => api.get("/site-lock").then((r) => r.data);
export const submitSiteUnlock = (password) =>
  api.post("/site-lock/unlock", { password }).then((r) => r.data);
export const validateDiscount = (code, items) =>
  api.post("/discounts/validate", { code, items }).then((r) => r.data);
export const stripeCheckoutOrder = (payload) =>
  api.post("/checkout/orders", payload).then((r) => r.data);
export const stripeCheckoutTickets = (payload) =>
  api.post("/checkout/tickets", payload).then((r) => r.data);
